var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLibrary(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_library"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.625 6.75H3.375C2.75368 6.75 2.25 7.25368 2.25 7.875V31.5C2.25 32.1213 2.75368 32.625 3.375 32.625H5.625C6.24632 32.625 6.75 32.1213 6.75 31.5V7.875C6.75 7.25368 6.24632 6.75 5.625 6.75Z",
    stroke: "#0076BE",
    strokeWidth: 2.25,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M7.875 15.75H16.875M7.875 28.125H16.875",
    stroke: "#0076BE",
    strokeWidth: 2.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M15.75 11.25H9C8.37868 11.25 7.875 11.7537 7.875 12.375V31.5C7.875 32.1213 8.37868 32.625 9 32.625H15.75C16.3713 32.625 16.875 32.1213 16.875 31.5V12.375C16.875 11.7537 16.3713 11.25 15.75 11.25Z",
    stroke: "#0076BE",
    strokeWidth: 2.25,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M23.625 3.375H19.125C18.5037 3.375 18 3.87868 18 4.5V31.5C18 32.1213 18.5037 32.625 19.125 32.625H23.625C24.2463 32.625 24.75 32.1213 24.75 31.5V4.5C24.75 3.87868 24.2463 3.375 23.625 3.375Z",
    stroke: "#0076BE",
    strokeWidth: 2.25,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M29.7043 6.75771L26.8637 7.05654C26.0818 7.1388 25.5151 7.87005 25.603 8.68076L28.0583 31.2926C28.1469 32.1033 28.8577 32.6988 29.6396 32.6172L32.4802 32.3184C33.2621 32.2361 33.8288 31.5049 33.741 30.6942L31.2892 8.08591C31.197 7.27169 30.4862 6.67544 29.7043 6.75771Z",
    stroke: "#0076BE",
    strokeWidth: 2.25,
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLibrary);
export default __webpack_public_path__ + "static/media/library.c78277ce58b235765a49b120cefc23ff.svg";
export { ForwardRef as ReactComponent };